/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';

import { BrowserRouter, Routes, Route } from 'react-router-dom';

import api, { API_URL, APPNAME, AuthProvider } from './util/api.js';

import Home from './home.js';
import ElegantGallery from './gallery.js';
import Navbar from './header.js';

import AssociationMembers from './members.js';

import Register from './Register.js';
import Dashboard from './dashboard.js';
import Login from './login.js';
import ProvideEmail from './forgot/forgot.js';
import Info from './components/info.js';
import Footer from './footer.js';
import BlogNewsletter from './blog/news.js';
import PremiumNewsDetail from './blog/details.js';
import ExcoPage from './exco.js';
import MembersPage from './members.js';
import AttendancePage from './attendance/AttendancePage.js';
import ChangePassword from './forgot/change_password.js';






function App() {

  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [canInstall, setCanInstall] = useState(false);
  const [showIosInstallGuide, setShowIosInstallGuide] = useState(false);
  const [showInstallModal, setShowInstallModal] = useState(false);


  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js')
        .then(() => console.log('SW registered'));
    }
  }, []);


  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setCanInstall(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);


  // Detect iOS Safari and show guide
  useEffect(() => {
    const isIos = () =>
      /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase());
    const isInStandaloneMode = () =>
      'standalone' in window.navigator && window.navigator.standalone;

    if (isIos() && !isInStandaloneMode()) {
      setShowIosInstallGuide(true);
    }
  }, []);


  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();

    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") {
      console.log("User accepted the install");
    } else {
      console.log("Install", "User dismissed the install", "info");
    }

    setDeferredPrompt(null);
    setCanInstall(false);
  };


  const [loadinginfo, setLoadingInfo] = useState(false);

  const getInfo = async () => {



    let response = await api.get(`${API_URL}/info`);
    if (response.data.status === true) {
      localStorage.setItem("info", response.data.info);

      setLoadingInfo(true);

      /* alert(response.data.info); */
    }



  };




  useEffect(() => {
    getInfo();
  }, []);

  if (loadinginfo === false) {
    return <div align="center"><h1>Loading...</h1></div>;

  }




  return (
    <>

      <BrowserRouter>

        <AuthProvider>
          <div style={styles.container} aria-live="polite">

            <Navbar />

            {/* Component-scoped styles & keyframes */}
            <style>{`
                   /* Keyframes */
                   @keyframes float {
                     0% { transform: translateY(0px) translateX(0); }
                     50% { transform: translateY(-18px) translateX(6px); }
                     100% { transform: translateY(0px) translateX(0); }
                   }
                   @keyframes slowFloat {
                     0% { transform: translateY(0px); }
                     50% { transform: translateY(-10px); }
                     100% { transform: translateY(0px); }
                   }
                   @keyframes fadeInUp {
                     from { opacity:0; transform: translateY(12px); }
                     to { opacity:1; transform: translateY(0); }
                   }
                   @keyframes pulseBtn {
                     0% { box-shadow: 0 8px 32px rgba(10,61,98,0.10); transform: translateY(0); }
                     50% { box-shadow: 0 22px 48px rgba(10,61,98,0.10); transform: translateY(-3px); }
                     100%{ box-shadow: 0 8px 32px rgba(10,61,98,0.10); transform: translateY(0); }
                   }

                   @keyframes sheen {
                     0% { background-position: -200% 0; }
                     100% { background-position: 200% 0; }
                   }
           
                   /* Small utility classes */
                   .fadeInUp { animation: fadeInUp 0.85s ease both; }
                   .delay-100 { animation-delay: 0.1s; }
                   .delay-200 { animation-delay: 0.22s; }
                   .delay-300 { animation-delay: 0.42s; }
                   .pulseBtn { animation: pulseBtn 3.8s ease-in-out infinite; }
           
                   /* Responsive nav display control */
                   @media (min-width: 980px) {
                     .navDesktop { display: flex !important; }
                     .navMobileToggle { display: none !important; }
                   }
                   @media (max-width: 979px) {
                     .navDesktop { display: none !important; }
                     .navMobileToggle { display: block !important; }
                   }
           
                   /* Mobile slide-in */
                   .mobilePanel {
                     transform-origin: right center;
                     transition: transform 400ms cubic-bezier(.17,.67,.83,.67), opacity 300ms;
                   }
                   .mobilePanel.closed { transform: translateX(110%); opacity: 0; pointer-events: none; }
                   .mobilePanel.open { transform: translateX(0%); opacity: 1; pointer-events: auto; }




                 `}</style>


            <style>{`
              @keyframes fadeInUp {
                from { opacity:0; transform: translateY(20px); }
                to { opacity:1; transform: translateY(0); }
              }

              @keyframes floatBtn {
                0% { transform: translateY(0); }
                50% { transform: translateY(-6px); }
                100% { transform: translateY(0); }
              }

              .installBtn {
                position: fixed;
                bottom: 24px;
                right: 24px;
                background: linear-gradient(135deg, #0A3D62, #3C91E6);
                color: #fff;
                padding: 14px 18px;
                border-radius: 50px;
                font-weight: 600;
                cursor: pointer;
                box-shadow: 0 12px 30px rgba(0,0,0,0.2);
                z-index: 9999;
                animation: floatBtn 3s infinite ease-in-out;
                transition: 0.3s;
              }

              .installBtn:hover {
                transform: scale(1.05);
              }

              .installModal {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0,0,0,0.5);
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 10000;
              }

              .installCard {
                background: #fff;
                padding: 28px;
                border-radius: 16px;
                max-width: 400px;
                width: 90%;
                animation: fadeInUp 0.4s ease;
                text-align: center;
              }

              .installCard h3 {
                margin-bottom: 12px;
              }

              .installCard p {
                font-size: 14px;
                margin-bottom: 20px;
                color: #555;
              }

              .installActions {
                display: flex;
                gap: 10px;
                justify-content: center;
              }

              .btnPrimary {
                background: #0A3D62;
                color: #fff;
                padding: 10px 16px;
                border-radius: 8px;
                cursor: pointer;
                border: none;
              }

              .btnSecondary {
                background: #eee;
                padding: 10px 16px;
                border-radius: 8px;
                cursor: pointer;
                border: none;
              }

              @media(max-width: 600px){
                .installBtn {
                  bottom: 16px;
                  right: 16px;
                  padding: 12px 16px;
                  font-size: 14px;
                }
              }
            `}</style>

            {/* NAVBAR */}




            <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/gallery' element={<ElegantGallery />} />
              <Route path='/register' element={<Register />} />
              <Route path='/login' element={<Login />} />
              <Route path='/forgot_password' element={<ProvideEmail />} />
              <Route path='/change_password' element={<ChangePassword />} />
              <Route path='/excos' element={<ExcoPage />} />
              <Route path='/members' element={<MembersPage />} />
              <Route path='/dashboard' element={<Dashboard />} />
              <Route path='/news' element={<BlogNewsletter type='article'  from="pagination" />} />
               <Route path='/sermon' element={<BlogNewsletter type='sermon'  from="pagination" />} />

              <Route path='/news/:id' element={<PremiumNewsDetail />} />

              <Route path='/attendance' element={<AttendancePage />} />
            </Routes>



            {/*  <Footer/> */}

            {/* FOOTER */}

            <Footer />

            {/* INSTALL BUTTON */}
            {(canInstall || showIosInstallGuide) && (
              <div
                className="installBtn"
                onClick={() => setShowInstallModal(true)}
              >
                📲 Install App
              </div>
            )}






            {/* INSTALL MODAL */}
            {showInstallModal && (
              <div className="installModal">
                <div className="installCard">
                  <h3>Install This App</h3>

                  {canInstall && (
                    <p>
                      Add this app to your device for faster access and a better experience.
                    </p>
                  )}

                  {showIosInstallGuide && (
                    <p>
                      On iPhone/iPad: Tap <b>Share</b> → then <b>"Add to Home Screen"</b>.
                    </p>
                  )}

                  <div className="installActions">
                    {canInstall && (
                      <button className="btnPrimary" onClick={handleInstall}>
                        Install Now
                      </button>
                    )}

                    <button
                      className="btnSecondary"
                      onClick={() => setShowInstallModal(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}


          </div>
        </AuthProvider>
      </BrowserRouter>

    </>
  )
}

const styles = {
  container: {
    fontFamily: "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
    color: "#08324A",
    lineHeight: 1.5,
    overflowX: "hidden",
  },

  /* FOOTER */
  footer: {
    background: "#0A3D62",
    color: "#fff",
    padding: "34px 28px 40px",
    marginTop: 40,
    borderRadius: 12,
    marginLeft: 12,
    marginRight: 12,
  },
  footerInner: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
    maxWidth: 1180,
    margin: "0 auto",
  },
  socials: {
    display: "flex",
    gap: 10,
    alignItems: "center",
  },
  socialLink: {
    padding: "8px 12px",
    borderRadius: 8,
    background: "rgba(255,255,255,0.06)",
    color: "#fff",
    textDecoration: "none",
    fontWeight: 700,
  },
  copyright: {
    marginTop: 18,
    maxWidth: 1180,
    marginLeft: "auto",
    marginRight: "auto",
    opacity: 0.9,
    fontSize: 13,
  },
};

export default App
